import React from "react";

function SegmentationDataLabellingPage() {
  return <div>SegmentationDataLabellingPage</div>;
}

export default SegmentationDataLabellingPage;
